export default __webpack_public_path__ + "static/media/prizebg.b6c7db0f.png";